<div class="inspections-page">
  <ysh-table-set [dataSource]="dataSource" (onItemTap)="didTapItem($event)"/>
</div>
